import { ModelMixin } from '../core/base-generic.model';

export class KycKybWave extends ModelMixin<KycKybWave>() {
    protected static _serializeAttributes = ['startDate', 'deadline'];
    protected static _version = 'v2';

    get name(): string {
        return this._attributes['name'];
    }

    get startDate(): Date | undefined {
        return this._attributes['startDate'];
    }

    get deadline(): Date | undefined {
        return this._attributes['deadline'];
    }

    get isNumberedWave(): boolean {
        return !!this.name.match(/Wave\s\d+/);
    }

    get verificationDays(): number | undefined {
        return this._attributes['verificationDays'];
    }
}
